import { inject, ref, watch } from 'vue';
import { settingValue } from '@/utils/site-utils';

const useGridLayout = (field) => {
  const { deviceType } = inject('device-common');
  const result = ref([0, 24]);
  watch(
    () => [deviceType, field],
    ([_deviceType, _field]) => {
      const [start, span] = settingValue(_field, '0-24')
        .split('-')
        .map((x) => Number(x) ?? 0);
      if (['mobile', 'tablet'].includes(_deviceType)) {
        result.value = [Math.min(Math.floor(start / 2), 1), Math.min(Math.floor(span / 2), 1)];
      } else {
        result.value = [start, span];
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );
  return result;
};
export default useGridLayout;
